import { render, staticRenderFns } from "./StepOther.vue?vue&type=template&id=16d74ba3&"
import script from "./StepOther.vue?vue&type=script&lang=js&"
export * from "./StepOther.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports